import {
  GOLD_500,
  GOLD_550,
  hexToRGB,
  RED_450,
  RED_550,
} from '@wandb/weave/common/css/globals.styles';
import {Select} from '@wandb/weave/components/Form/Select';
import {IconName} from '@wandb/weave/components/Icon';
import {Pill} from '@wandb/weave/components/Tag';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {RunQueueItemInfoDetails} from '../../../generated/graphql';
import * as S from './SelectRunQueueItemInfo.styles';

export type InfoOption = RunQueueItemInfoDetails & {
  type: string;
  value: string;
};

type CircleProps = {
  isError: boolean;
};

export const Circle = styled.div<CircleProps>`
  border-radius: 50%;
  width: 22px;
  height: 22px;
  background-color: ${props =>
    props.isError ? hexToRGB(RED_450, 0.15) : hexToRGB(GOLD_500, 0.16)};
  color: ${props => (props.isError ? RED_550 : GOLD_550)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

const OptionLabel = (props: InfoOption) => {
  const {type} = props;
  const isError = type === 'Error';
  const icon = isError ? 'failed' : 'warning';
  const pillColor = isError ? 'red' : 'gold';
  return (
    <S.SelectOption>
      <S.SelectOptionLabel>{props.message}</S.SelectOptionLabel>
      <S.SelectOptionPill>
        <Pill icon={icon as IconName} label={type} color={pillColor} />
      </S.SelectOptionPill>
    </S.SelectOption>
  );
};

type SelectRunQueueItemInfoProps = {
  options: InfoOption[];
  defaultInfoOption: InfoOption;
  selected: InfoOption;
  onSelectInfo: (option: InfoOption) => void;
};

export const SelectRunQueueItemInfo = ({
  options,
  defaultInfoOption,
  selected,
  onSelectInfo,
}: SelectRunQueueItemInfoProps) => {
  const onChange = (option: InfoOption | null) => {
    if (option) {
      onSelectInfo(option);
    }
  };

  return (
    <Select<InfoOption>
      options={options}
      formatOptionLabel={OptionLabel}
      defaultValue={defaultInfoOption}
      onChange={onChange}
      value={selected}
      size="medium"
      placeholder="Select an error or warning..."
    />
  );
};
